import React, { AnchorHTMLAttributes } from 'react';

type LinkProps = React.PropsWithRef<AnchorHTMLAttributes<HTMLAnchorElement>>;

export const DefaultLink = React.forwardRef<HTMLAnchorElement, React.PropsWithChildren<LinkProps>>(
  ({ children, ...rest }, ref) => (
    <a ref={ref} {...rest}>
      {children}
    </a>
  )
);

DefaultLink.displayName = 'DefaultLink';
